import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import moment from 'jalali-moment';
import { toast } from "react-toastify";

import { swal } from "../../../utils/methods";
import { _post } from "../../../utils/network";

import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb.component';
import FormField from "../../../components/Form/FormField/FormField.component";
import LoadingButton from '../../../components/LoadingButton/LoadingButton.component';

const SignalCommentsCreate = ({ componentType='create' }) => {
	const { t } = useTranslation();
	const { id } = useParams();
	const navigate = useNavigate();
	const breadcrumbItems = [
		{ title: t('dashboard'), link: '/dashboard' },
		{ title: t('signal_comments'), link: '/signal-comments-list' },
		{ title: t(componentType) }
	];
	const confirmSwal = statements => {
		swal(() => statements(), {
			text: t('are_you_sure_to_do_this'),
			confirmButtonText: t('yes'),
			cancelButtonText: t('no')
		});
	};

	const [createButtonIsLoading, setCreateButtonIsLoading] = useState(false);
	const createSignalComment = async (event) => {
		event.preventDefault();
		if(createButtonIsLoading)
			return 0;
		let body = {
			// signal_id: id,
			// signal_state: status
		};
		confirmSwal(async () => {
			setCreateButtonIsLoading(true);
			let response = await _post('/signalcomments/admin/' + componentType, body);
			setCreateButtonIsLoading(false);
			switch(response.code){
				case 200:
					toast.success(response[t('api_message')]);
					if(componentType === 'create')
						event.target.reset();
					break;
				default:
					toast.error(response[t('api_message')]);
			}
		});
	}
	
	const [signalComment, setSignalComment] = useState({});
	const getSignalComment = async () => {
		let body = {
			signalcomment_id: id
		};
		let response = await _post('/signalcomments/admin/getOne', body);
		switch(response.code){
			case 200:
				setSignalComment(response.data.signalcomment);
				break;
			default:
				toast.error(response[t('api_message')]);
		}
	};

	const [deleteButtonIsLoading, setDeleteButtonIsLoading] = useState(false);
	const deleteSignalComment = async () => {
		if(deleteButtonIsLoading)
			return 0;
		let body = {
			signalcomment_id: id
		};
		confirmSwal(async () => {
			setDeleteButtonIsLoading(true);
			let response = await _post('/signalcomments/admin/delete', body);
			setDeleteButtonIsLoading(false);
			switch(response.code){
				case 200:
					navigate("/signal-comments-list");
					break;
				default:
					toast.error(response[t('api_message')]);
			}
		});
	};

	useEffect(() => {
		if(componentType === 'edit')
			getSignalComment();
	}, []);

	return (
		<>
			<Breadcrumb items={breadcrumbItems} />
			<div className="card mb-3">
				<div className="card-header">
					<h5 className="mb-0">{t(componentType)} {t('signal_comment')}</h5>
				</div>
				<div className="card-body bg-light">
					<form onSubmit={createSignalComment}>
						<div className="row gx-2">
							<FormField fieldKey="signalCommentCreationDate" title={t('creation_date')} value={signalComment?.create_date ? moment(signalComment?.create_date?.substring(0, 10), 'YYYY-MM-DD').locale('fa').format('jYYYY/jMM/jDD') : ''} disabled ltr />
							<FormField fieldKey="signalCommentAnalyser" title={t('analyser')} value={signalComment?.user_id_information?.user_fullname} disabled rtl />
							<FormField type="text" fieldKey="signalCommentText" title={t('comment')} value={signalComment?.signalcomment_information?.title + ': ' + signalComment?.signalcomment_information?.description} disabled rtl />
						</div>
						<div>
							{componentType === 'create' ?
								<LoadingButton className="btn btn-primary d-inline-block mt-3 me-2" type="submit" name="create" isLoading={createButtonIsLoading}>
									<i className="fa fa-save"></i> {t('create')}
								</LoadingButton>
							:
								<LoadingButton className="btn btn-danger d-inline-block mt-3" onClick={deleteSignalComment} type="button" name="delete" isLoading={deleteButtonIsLoading}>
									<i className="fa fa-trash"></i> {t('delete')}
								</LoadingButton>
							}
						</div>
					</form>
				</div>
			</div>
		</>
	);
};

export default SignalCommentsCreate;
